import React, { Component } from 'react'
import {View, StyleSheet, Platform} from 'react-native'
import { JDText, JDImage, JDDevice, JDTouchable} from '@jdreact/jdreact-core-lib'
import PropTypes from 'prop-types'
import { imgProcess } from '../../../utils/tools'
import {
  listTel
} from '../../../utils/image'
import { zufangCall } from '../../../utils/callPhone'
import { pt, sendClickDataWithJsonParam, } from '../../../components/utiles';

import vrImg from '../../../images/detail/vr.png'
import videoImg from '../../../images/detail/video.png'

const isWeb = Platform.OS === 'web';
export default class HouseItemCard extends Component {
	static propTypes = {
		recommendHouseItem: PropTypes.object,
		index: PropTypes.number,
	};

	render() {
		const {
			mainPic, // 主图
			houseTitle, // 房源标题
			houseType,
			roomArea,
			totalPrice,
			unitPrice, // 总价, 单价
			buildingName,
			unitType,
			telephone,
			extentionPhone,
			skuId
		} = this.props.recommendHouseItem || {};
		const {index, pageId} = this.props;
		const unitTypeMy = unitType === 1 ? '元/m²/天' : (unitType === 2 ? '元/m²/月' : (unitType === 5 ? '元/工位/月' : ''))
		return (
				<View style={houseItemStyles.houseBox}>
					<View>
						<JDImage source={{uri: imgProcess(mainPic)}} style={houseItemStyles.houseImg}></JDImage>
						{/* <View style={houseItemStyles.flagWrapper}>
							{
								!!vrUrl && (
									<JDImage source={vrImg} style={houseItemStyles.vrImg}></JDImage>
								)
							}
							{
								!!videoId && (
									<JDImage source={videoImg} style={houseItemStyles.videoImg}></JDImage>
								)
							}
						</View> */}
					</View>
					{index != 0 && <View style={houseItemStyles.hasLine}/>}
					<View style={houseItemStyles.houseInfo}>
						<JDText style={houseItemStyles.houseTitle} numberOfLines={2}>{houseTitle}</JDText>
						<JDText style={houseItemStyles.featureWrap} numberOfLines={1}>
							<JDText style={houseItemStyles.squareWrapper}>
								<JDText style={houseItemStyles.featureItem}>{roomArea}m²</JDText>
							</JDText>
							<JDText style={houseItemStyles.featureItem}>/{buildingName}</JDText>
						</JDText>
						<View style={houseItemStyles.housePrice}>
							{
								houseType === 1 && ( // 出售
										<View style={houseItemStyles.totalPriceBox}>
											<JDText style={houseItemStyles.totalPrice}>{totalPrice}</JDText>
											<JDText style={houseItemStyles.priceUnit}>万元</JDText>
										</View>
								)
							}
							{
								houseType === 2 && ( // 出租
									<View style={houseItemStyles.totalPriceBox}>
										<JDText style={houseItemStyles.totalPrice}>{unitPrice}</JDText>
										<JDText style={houseItemStyles.priceUnit}>{unitTypeMy}</JDText>
									</View>
								)
							}
						</View>
					</View>
					<JDTouchable style={houseItemStyles.telCallCon} onPress={() => {
							sendClickDataWithJsonParam({
								event_id: pageId === 'OfficeBuilding_SearchList'? 'OfficeBuilding_SearchList_HouseResource_Contact' : 'OfficeBuilding_HouseResource_Contact',
								page_id: pageId,
								json_param: {
									brokerPhoneNumber: (extentionPhone || telephone ) + '',
									skuid: skuId + '',
									sku_order: index + ''
								},
							})
							zufangCall(extentionPhone, telephone)
						}}>
						<JDImage style={houseItemStyles.telCall} source={listTel}></JDImage>
					</JDTouchable>
				</View>
		)
	}
}
const houseItemStyles = StyleSheet.create({
	houseBox: {
		position: 'relative',
		flexDirection: 'row',
		paddingHorizontal: JDDevice.getRpx(24),
		paddingVertical: JDDevice.getRpx(24),
		...Platform.select({ // 不同的平台执行不同的样式
			ios: {
				// shadowColor: '#000',
				// shadowOffset: {h: 0, w: JDDevice.getRpx(2)}, // ios设置阴影
				// shadowRadius: JDDevice.getRpx(8),
				// shadowOpacity: 0.08
			},
			// android: {
			// 	backgroundColor: "#fff", // 要想elevation有效，必须设置backgroundColor
			// 	elevation: 0.3 // 设置Android机上的阴影
			// },
			web: {
				// boxShadow: '0 2px 8px 0 rgba(0,0,0,0.08)'
			}
		})
	},
	houseImg: {
		width: JDDevice.getRpx(220),
		height: JDDevice.getRpx(163),
		borderRadius: JDDevice.getRpx(12),
	},
	houseInfo: {
		flex:1,
		paddingLeft: JDDevice.getRpx(24),
		backgroundColor: "#fff",
		marginTop: JDDevice.getRpx(-4)
	},
	houseTitle: {
		marginBottom: JDDevice.getRpx(8),
		fontSize: JDDevice.getRpx(30),
		lineHeight: JDDevice.getRpx(36),
		fontFamily: 'PingFang SC',
		fontWeight: "500",
		color: '#1A1A1A'
	},
	featureWrap: {
		marginBottom: JDDevice.getRpx(14),
		flexDirection: 'row',
		alignItems: 'center',
		flexWrap: 'nowrap',
		height:JDDevice.getRpx(28),
		lineHeight:JDDevice.getRpx(28),
		fontSize: JDDevice.getRpx(11)
	},
	featureItem: {
		fontWeight:'normal',
		flexShrink:0,
		..._getFontStyle(22, '#555555')
	},
	housePrice: {
		position: 'absolute',
		flexDirection: 'row',
		alignItems: 'baseline',
		paddingTop: JDDevice.getRpx(10),
		bottom: 0,
		left: JDDevice.getRpx(24),
	},
	totalPriceBox: {
		flexDirection: 'row',
		alignItems: 'baseline',
		marginRight: JDDevice.getRpx(15),
		zIndex: 30,
	},
	totalPrice: {
		..._getFontStyle(32, '#FA2C19'),
		fontWeight: 'normal',
		fontFamily: 'JDZhengHT-Regular',
	},
	priceUnit: {
		..._getFontStyle(28, '#FA2C19'),
		fontWeight: '500',
		...Platform.select({
			android: {
				lineHeight: JDDevice.getRpx(36)
			}
		})
	},
	unitPrice: {
		fontWeight:'normal',
		fontFamily: 'PingFang SC',
		..._getFontStyle(24, '#999999')
	},
	// 标签wrapper
	flagWrapper: {
		position: 'absolute',
		top: JDDevice.getRpx(111),
		flexDirection: 'row',
	},
	vrImg: {
		width: JDDevice.getRpx(36),
		height: JDDevice.getRpx(36),
		marginLeft: JDDevice.getRpx(16)
	},
	videoImg: {
		width: JDDevice.getRpx(36),
		height: JDDevice.getRpx(36),
		marginLeft: JDDevice.getRpx(12)
	},
	squareWrapper:{
		flexDirection: 'row'
	},
	// 平方
	squareMin:{ 
		top: -JDDevice.getRpx(4),
		fontSize: JDDevice.getRpx(16),
		position:'relative',
		color:'#999',
		transform: [{ scale: .8 }]
	},
	square:{
		top: JDDevice.getRpx(0),
		fontSize: JDDevice.getRpx(16),
		position:'relative',
		color:'#999999',
		transform: [{ scale: .8 }]
	},
	// line
	hasLine:{
		width:'58%',
		height:0,
		borderBottomWidth: JDDevice.getDpx(1),
		borderStyle:'solid',
		borderColor:'rgba(0,0,0,0.08)',
		position: 'absolute',
		top: JDDevice.getRpx(-4),
		right: JDDevice.getRpx(24),
		// transform:scaleY()
	},
	telCallCon:{
		position: 'absolute',
		bottom: 0,
		padding: JDDevice.getRpx(20),
		right: JDDevice.getRpx(6),
	},
	telCall:{
		width:JDDevice.getRpx(56),
		height:JDDevice.getRpx(56),
	},
});
function _getFontStyle(size, color) {
	return {
		fontSize: JDDevice.getRpx(size),
		color: color,
		fontFamily: 'PingFang SC'
	}
}